var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPremiumFeature = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .premium-icon {\r\n        clip-path: url(#clip-Premium_Feature_White);\r\n      }\r\n\r\n      .premium-color {\r\n        fill: #fff;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Premium_Feature_White"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Premium_Feature_White",
    "data-name": "Premium Feature \\u2013 White",
    className: "premium-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "premium",
    transform: "translate(-6.356 0.58)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6005",
    "data-name": "Group 6005",
    transform: "translate(6.919 11.224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6004",
    "data-name": "Group 6004"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12749",
    "data-name": "Path 12749",
    className: "premium-color",
    d: "M25.121,306.427a1.148,1.148,0,0,0-1.576-.391l-3.706,1.893a1.148,1.148,0,0,0-.8-1.967h-3.48c-1.443,0-2.123-1.02-4.555-1.02v-.51H6.919v7.653H11v-2.041s.664.46,1.531,1.02a2.563,2.563,0,0,0,1.726.51h3.8a3.528,3.528,0,0,0,1.48-.458c.527-.255,5.192-3.112,5.192-3.112A1.148,1.148,0,0,0,25.121,306.427ZM9.47,310.553H8.45v-4.592H9.47Z",
    transform: "translate(-6.919 -304.431)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6007",
    "data-name": "Group 6007",
    transform: "translate(10.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6006",
    "data-name": "Group 6006"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12750",
    "data-name": "Path 12750",
    className: "premium-color",
    d: "M114.491,4.092l-4.108-.268L108.859,0l-1.525,3.824-4.108.268,3.166,2.632-1.014,3.99,3.481-2.2,3.481,2.2-1.014-3.99Z",
    transform: "translate(-103.226)"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPremiumFeature, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/PremiumFeature.f0899800.svg";
export { ForwardRef as ReactComponent };